const {KitModule, registerModule} = window;

// no space as it will be triggered from click
const OPEN_SUBNAV_KEYS = ['Enter', 'ArrowDown'];

class Nav extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.$menuCheckbox = document.querySelector('.nav-menu-checkbox');
    this.searchIsOpen = false;
  }

  bindEvents() {
    // events
    this.$element.addEventListener('keydown', this);
    this.$element.addEventListener('click', this);
    this.$menu.addEventListener('mouseover', this);
    this.$menu.addEventListener('mouseout', this);
    this.$menu.addEventListener('focusin', this);
    this.$menuCheckbox.addEventListener('change', this);
    this.$menuLabel.addEventListener('click', this.onMenuLabelClick.bind(this));
    // browser hack - fire click on touchstart, avoid :hover & focus
    this.$menuLabel.addEventListener('touchstart', function() {});

    window.addEventListener('searchopen', this);
    window.addEventListener('searchclose', this);

    this.bindMediaQuery();

    window.addEventListener('resize', this);
    window.addEventListener('scroll', this, {passive: true});
  }

  // Hide Casepoint text when we scroll

  // onscroll() {
  //   const scrollPos = window.scrollY;
  //   const navHeight = this.$menu.offsetHeight;
  //   const svgPath = this.$branding.querySelector('svg path:last-child');
  //   if (scrollPos > navHeight) {
  //     svgPath.style.opacity = '0';
  //   } else {
  //     svgPath.style.opacity = '1';
  //   }
  // }

  onscroll() {
    // Share the geometry batch so this class write cannot precede its reads.
    scheduleHeightUpdate();
  }

  // Hide Casepoint text when we scroll

  onresize() {
    if (this.isDesktop) {
      this.$menuCheckbox.checked = false;
      this.isMenuOpen = this.$menuCheckbox.checked;
      document.documentElement.classList.remove('nav-menu-open', this.isMenuOpen);
    }
  }

  bindMediaQuery() {
    // get media query from custom property
    const rootStyle = getComputedStyle(document.documentElement);

    // max nav - mobile
    const maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
    this.maxMediaQuery = window.matchMedia(maxQuery);
    // listen and set initial
    this.maxMediaQuery.addEventListener('change', this.onMaxMediaChange.bind(this));
    this.onMaxMediaChange(this.maxMediaQuery);

    // min nav - desktop
    const minQuery = rootStyle.getPropertyValue('--min-nav-media-query');
    this.minMediaQuery = window.matchMedia(minQuery);
    // listen and set initial
    this.minMediaQuery.addEventListener('change', this.onMinMediaChange.bind(this));
    this.onMinMediaChange(this.maxMediaQuery);
  }

  onMaxMediaChange(mobileMediaQuery) {
    this.isMobile = mobileMediaQuery.matches;
  }

  onMinMediaChange(desktopMediaQuery) {
    this.isDesktop = desktopMediaQuery.matches;
  }

  onsearchopen() {
    this.searchIsOpen = true;
    if (this.isMenuOpen) this.$menuCheckbox.click();
  }

  onsearchclose() {
    this.searchIsOpen = false;
    if (this.isMobile) {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
    }
  }

  // toggle subnav on .nav__item__button click
  onclick(event) {
    const $nestedToggle = event.target.closest('.nav__subnav__toggle');
    if ($nestedToggle) {
      this.toggleNestedSubnav($nestedToggle);
      return;
    }

    const $itemButton = event.target.closest('.nav__item__button');
    if (!$itemButton) return;

    // Skip if this is a tab title (part of nav tabs functionality)
    if ($itemButton.classList.contains('nav__subnav__tabs-title')) return;

    const $item = $itemButton.closest('.nav__item');
    this.toggleSubnav($item);
  }

  onkeydown(event) {
    if (event.key === 'Escape') {
      this.closeSubnav();
      if (this.isMenuOpen) this.$menuCheckbox.click();
      return;
    }
    const isOpeningSubnav = OPEN_SUBNAV_KEYS.includes(event.key) &&
      event.target.matches('.nav__item__button--subnav');

    if (isOpeningSubnav) {
      event.preventDefault();
      const $item = event.target.closest('.nav__item');
      if ($item === this.$openSubnavItem && event.key !== 'ArrowDown') {
        this.closeSubnav();
      } else {
        this.openSubnav($item);
      }
    }
  }

  // close subnav if hovered over other item, desktop only
  onmouseover(event) {
    const $item = event.target.closest('.nav__item');
    // Child-to-child pointer movement does not change the visible panel.
    if (!$item || $item.contains(event.relatedTarget)) return;
    this.hydrateSpotlights($item);
    if (this.isMobile) return;
    if ($item && $item !== this.$openSubnavItem) this.closeSubnav();
    this.setMediaVisibility($item, true);
  }

  onmouseout(event) {
    if (this.isMobile) return;
    const $item = event.target.closest('.nav__item');
    if ($item && !$item.contains(event.relatedTarget) && $item !== this.$openSubnavItem) this.setMediaVisibility($item, false);
  }

  setMediaVisibility($item, visible) {
    if ($item) $item.dispatchEvent(new CustomEvent('backgroundvideos:visibility', {bubbles: true, detail: {visible}}));
  }

  onfocusin(event) {
    this.hydrateSpotlights(event.target.closest('.nav__item'));
  }

  // Cards stay outside the initial DOM until their panel is approached. Moving
  // template content before opening preserves layout and keyboard focus order.
  hydrateSpotlights($item) {
    const $templates = $item?.querySelectorAll('template[data-nav-spotlights]');
    if (!$templates?.length) return;
    $templates.forEach(($template) => {
      $template.replaceWith($template.content.cloneNode(true));
    });
    // Let media loaders register inserted cards without watching all DOM mutations.
    $item.dispatchEvent(new Event('backgroundvideos:register', {bubbles: true}));
  }

  onchange() {
    this.isMenuOpen = this.$menuCheckbox.checked;
    document.documentElement.classList.toggle('nav-menu-open', this.isMenuOpen);
  }

  // programmatically trigger click to avoid browser setting scroll position to top
  onMenuLabelClick(event) {
    event.preventDefault();

    if (this.searchIsOpen) {
      const customEvent = new Event('menulabelclicked');
      window.dispatchEvent(customEvent);
    }

    this.$menuCheckbox.click();
  }

  openSubnav($item) {
    if (!$item) return;

    this.hydrateSpotlights($item);

    this.closeSubnav(this.$openSubnavItem); // close previous

    this.$openSubnavItem = $item;
    this.$openSubnavButton = $item.querySelector('.nav__item__button');
    this.$openSubnavItem.classList.add('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'true');
    // A hydrated panel may already intersect while CSS still hides it.
    this.setMediaVisibility($item, true);
  }

  closeSubnav() {
    if (!this.$openSubnavItem) return;

    this.$openSubnavItem.classList.remove('is-subnav-open');
    this.$openSubnavButton.setAttribute('aria-expanded', 'false');
    // Desktop hover can still expose the panel after its explicit open state ends.
    const remainsVisible = !this.isMobile && window.matchMedia('(hover: hover)').matches && this.$openSubnavItem.matches(':hover');
    this.setMediaVisibility(this.$openSubnavItem, remainsVisible);
    this.$openSubnavItem = null;
    this.$openSubnavButton = null;
  }

  toggleSubnav($item) {
    if ($item === this.$openSubnavItem) {
      this.closeSubnav();
    } else {
      this.openSubnav($item);
    }
  }

  // toggle a nested submenu (e.g. a link with children inside a subnav list),
  // independent of the top-level subnav open/close state
  toggleNestedSubnav($toggle) {
    const isExpanded = $toggle.getAttribute('aria-expanded') === 'true';
    $toggle.setAttribute('aria-expanded', String(!isExpanded));
    $toggle.closest('.nav__subnav__item').classList.toggle('is-subnav-open', !isExpanded);
  }

  unmount() {
    this.$element.removeEventListener('keydown', this);
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
    this.$menu.removeEventListener('mouseover', this);
    this.$menu.removeEventListener('mouseout', this);
    this.$menu.removeEventListener('focusin', this);
    this.$menuCheckbox.removeEventListener('change', this);
  }
}

registerModule('Nav', Nav);

// The inline template restores dismissal before paint; storage can be disabled.
document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('popup');
  const closePopupButton = document.getElementById('closePopup');
  if (!popup || !closePopupButton) return;

  closePopupButton.addEventListener('click', () => {
    popup.style.display = 'none';
    try {
      localStorage.setItem('popupClosedAt', Date.now());
    } catch (e) {
      // Dismissal still works for this page when the browser denies storage.
    }
    updateHeights();
  });
});

const lastNavHeights = new Map();
let heightUpdateFrame = null;
let searchBar = null;
let searchScrollThreshold = 0;
let searchScrolled = false;

/**
 * Updates the heights of the header and dropdown elements.
 *
 * This function calculates the heights of the header and dropdown elements
 * and sets the corresponding CSS variables (`--dynamic-header-height` and
 * `--dynamic-dropdown-height`) to dynamically adjust styles.
 */
function updateHeights() {
  const header = document.querySelector('header');
  const dropdown = document.getElementById('popup');

  let headerHeight = 0;
  let dropdownHeight = 0;

  if (header) {
    // Get the header's visible height (including scrolled portion)
    const headerRect = header.getBoundingClientRect();
    headerHeight = headerRect.height; // The height of the header in view
  }

  if (dropdown) {
    // Calculate visible portion of the dropdown
    const dropdownRect = dropdown.getBoundingClientRect();
    if (dropdownRect.top >= 0) {
      dropdownHeight = dropdownRect.height; // Dropdown fully visible
    } else if (dropdownRect.bottom > 0) {
      dropdownHeight = dropdownRect.bottom; // Dropdown partially visible
    } else {
      dropdownHeight = 0; // Dropdown not visible
    }
  }

  // Subtract dropdown height when scrolled out of view
  headerHeight = Math.round(headerHeight);
  dropdownHeight = Math.round(dropdownHeight);
  const totalNavHeight = headerHeight + dropdownHeight;

  // Set CSS variables dynamically
  if (document.documentElement) {
    // Root writes invalidate styles across the page. Ignore sub-pixel jitter
    // and keep stable heights from triggering another style recalculation.
    const heights = [
      ['--total-nav-height', totalNavHeight],
      ['--dynamic-header-height', headerHeight],
      ['--dynamic-dropdown-height', dropdownHeight],
    ];
    heights.forEach(([name, value]) => {
      if (lastNavHeights.get(name) === value) return;
      document.documentElement.style.setProperty(name, `${value}px`);
      lastNavHeights.set(name, value);
    });
  }
}

/** Schedule one geometry read/write batch for a burst of scroll/resize events. */
function scheduleHeightUpdate() {
  if (heightUpdateFrame !== null) return;
  heightUpdateFrame = window.requestAnimationFrame(() => {
    heightUpdateFrame = null;
    // Read scroll state before root writes; scrollY can itself flush layout.
    const scrollY = window.scrollY;
    const nav = document.querySelector('header.nav');
    const navScrolled = scrollY > 10;
    const navStateChanged = nav && nav.classList.contains('is-scrolled') !== navScrolled;
    updateHeights();
    if (navStateChanged) nav.classList.toggle('is-scrolled', navScrolled);
    if (!searchBar) return;
    const scrolled = scrollY > searchScrollThreshold;
    if (scrolled === searchScrolled) return;
    searchBar.classList.toggle('scrolled', scrolled);
    searchScrolled = scrolled;
  });
}

// Call the function initially and on relevant events
document.addEventListener('DOMContentLoaded', updateHeights); // Ensure DOM is loaded
// Announcement content can change height after the DOM is ready.
window.addEventListener('load', updateHeights);
window.addEventListener('resize', scheduleHeightUpdate, {passive: true});
window.addEventListener('scroll', scheduleHeightUpdate, {passive: true});
// Refresh the fixed panel offset immediately before the search becomes visible.
window.addEventListener('searchopen', updateHeights);


document.addEventListener('DOMContentLoaded', () => {
  const search = document.querySelector('.search');
  const header = document.getElementById('popup');

  if (!search || !header) return;
  searchBar = search;
  searchScrollThreshold = header.offsetHeight;
  searchScrolled = search.classList.contains('scrolled');
});

// Nav Tab functionality - Compact version
document.addEventListener('DOMContentLoaded', () => {
  // Desktop tabs
  document.querySelectorAll('.nav__subnav__tabs-radio').forEach((radio) => {
    radio.addEventListener('change', (e) => {
      if (!e.target.checked) return;
      const layout = e.target.closest('.nav__subnav__tabs-layout');
      const targetId = e.target.id.replace('tab-desktop-', '');

      layout.querySelectorAll('.nav__subnav__tabs-title').forEach((l) => l.classList.remove('active'));
      layout.querySelector(`label[for="${e.target.id}"]`)?.classList.add('active');
      layout.querySelectorAll('.nav__subnav__tabs-content').forEach((c) => c.style.display = 'none');
      layout.querySelector(`[data-tab-content="${targetId}"]`).style.display = 'flex';
    });
  });

  // Mobile tabs
  document.querySelectorAll('.nav__subnav__tabs-mobile .nav__subnav__tabs-title').forEach((label) => {
    label.addEventListener('click', (e) => {
      const input = document.getElementById(label.getAttribute('for'));
      const tabItem = label.closest('.nav__subnav__tabs-item');

      if (input?.checked) {
        e.preventDefault();
        input.checked = false;
        tabItem.classList.remove('is-subnav-open');
      } else {
        document.querySelectorAll('.nav__subnav__tabs-mobile .nav__subnav__tabs-item').forEach((item) => item.classList.remove('is-subnav-open'));
        setTimeout(() => input?.checked && tabItem.classList.add('is-subnav-open'), 0);
      }
    });
  });

  // Initialize first tab
  document.querySelectorAll('.nav__subnav__tabs-layout').forEach((layout) => {
    layout.querySelector('.nav__subnav__tabs-radio:checked')?.dispatchEvent(new Event('change'));
  });
});
